import rawConfig from "./config.json";

const config = {
    safe2DriveApiBaseUrl: rawConfig.Safe2DriveApiBaseUrl,
    postcoderApiKey: process.env.REACT_APP_POSTCODER_API_KEY,
};

export default config;
